module.exports = "<div class=\"btn-group btn-group-toggle\" data-toggle=\"buttons\">\n  <label (click)=\"emitPeriodChange(period,i)\" *ngFor=\"let period of categoryNames; let i = index\" [class.active]=\"i === activeIndex\" class=\"btn btn-secondary\">\n    <input type=\"radio\" name=\"options\" id=\"{{period}}\"> {{ period }}\n  </label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.html
// module id = ./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.html
// module chunks = 0